<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>积分记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
        </el-card>
      </div>
      
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" ref="agentRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable >
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" @click="query" :loading="state">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state">重 置</el-button>
      </el-form>
      
      <el-table :data="integralData" border style="width: 100%" stripe>
        <el-table-column prop="softName" label="代理软件" width="220"></el-table-column>
        <el-table-column prop="type" label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type === '购买'" style="color: #237804" >{{scope.row.type}}</span>
            <span v-if="scope.row.type === '回收'" style="color: #d80821">{{scope.row.type}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="integralChange" label="积分变动" width="130"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="时间" width="165"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data(){
    return{
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      total:0,
      integralData:[],
      state:false,
      searchForm:{},
      allSoftName:"",
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getIntegralLog()
  },
  methods:{
    async getIntegralLog(){
      //console.log(this.queryInfo);
      const result = await this.$http.get("subAgentIntegralLog",{
        params: this.queryInfo
      });
      console.log('result',result);
      this.integralData = result.data.data.data
      this.total = result.data.data.total
    },

    async getCardTypeSoftName(){
      this.stateOver = true
      //const result = await this.$http.post("cardGetSoft", {email:this.email});
      //const result = await this.$http.post("cardGetSoft", {email:this.email});
      console.log('---------------');
      const result = await this.$http.get("getcardsoftlist",{
        params:this.queryInfo
      });
      this.stateOver = false
      console.log('getresult',result);
      this.allSoftNameObj = result.data.data.result
      this.allSoftName = result.data.data.result.map(element => {
        //console.log('result',element.softName);
        return element.softName
      })
      this.allCardType = result.data.data.resolve.map(element => {
        //console.log('resolve',element.cardName);
        return element.cardName
      })
      this.allSoftNameIntegral = result.data.data.result.map(element => {
        //console.log(element.softName+' - '+`[ 积分余额:${element.integral} ]`);
        return element.softName+' - '+`[ 积分余额:${element.integral} ]`
      })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getIntegralLog()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getIntegralLog()
    },
    refresh(){
      this.queryInfo.pagenum = 1
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.getIntegralLog()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getIntegralLog()
    },
    reSet(){
      this.queryInfo.pagenum = 1
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.getIntegralLog()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
</style>